module.exports = __webpack_public_path__ + "img/bg_saude.1e63618f.jpg";